import type { ReactNode } from 'react';
import { clsx } from 'clsx';

import classes from './ProfileCard.module.scss';

/**
 * p8: адаптивная сетка карточек профиля (свой и публичный, репетитор и ученик).
 * Колонки подстраиваются под ширину: 1 на телефоне, 2 на десктопе.
 */
export const ProfileGrid = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div className={clsx(classes.grid, className)}>{children}</div>
);

export interface ProfileCardProps {
  title?: ReactNode;
  icon?: ReactNode;
  children: ReactNode;
  /** Растянуть на всю ширину сетки. */
  wide?: boolean;
  className?: string;
  actions?: ReactNode;
}

export const ProfileCard = ({ title, icon, children, wide, className, actions }: ProfileCardProps) => (
  <section className={clsx(classes.card, wide && classes.wide, className)}>
    {title ? (
      <h2 className={classes.title}>
        {icon ? (
          <span className={classes.icon} aria-hidden>
            {icon}
          </span>
        ) : null}
        <span>{title}</span>
      </h2>
    ) : null}
    <div className={classes.body}>{children}</div>
    {actions ? <div className={classes.actions}>{actions}</div> : null}
  </section>
);

/** Пара «подпись - значение» с иконкой; одинаковая высота строк во всех карточках. */
export const ProfileField = ({ icon, label, children }: { icon?: ReactNode; label: ReactNode; children: ReactNode }) => (
  <div className={classes.field}>
    {icon ? (
      <span className={classes.fieldIcon} aria-hidden>
        {icon}
      </span>
    ) : null}
    <div className={classes.fieldCopy}>
      <p className={classes.fieldLabel}>{label}</p>
      <div className={classes.fieldValue}>{children}</div>
    </div>
  </div>
);

/** Заголовок карточки с иконкой - для существующих карточек со своей разметкой. */
export const ProfileCardTitle = ({ icon, children, className }: { icon?: ReactNode; children: ReactNode; className?: string }) => (
  <h2 className={clsx(classes.title, className)}>
    {icon ? (
      <span className={classes.icon} aria-hidden>
        {icon}
      </span>
    ) : null}
    <span>{children}</span>
  </h2>
);

export const profileCardClasses = { wide: classes.wide };
